import "../../utils/polyfillTextTrackCue";
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import 'videojs-contrib-ads';
import 'videojs-ima';
import { checkOperatingSystem } from "../../utils/utils";
import { ssaiAdParam } from '../../utils/utils';
export const VideoJS = (props) => {
  const [controlColor, setControlColor] = useState();
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  // const pauseRef = React.useRef(null);
  const { options, onReady, pauseVideo, isTrailer, poster, is_live, isRadioLive, isPlaylist, kids } = props;

  const location = useLocation()
  let uid = localStorage.getItem("gid");
  let user_id = localStorage.getItem("userId");
  if (user_id) {
    uid = user_id
  }
  const appInfo = {
    projectDetails: projectInfo
  }

  if (videojs.Vhs) {
    videojs.Vhs.xhr.beforeRequest = function (options) {
      if (options?.uri.includes(".m3u8?id=")) {
        options.headers = {
          pubid: projectInfo?.projectConfig?.pubid,
          channelid: projectInfo?.projectConfig?.channelid,
          uid: uid,
          "access-token": accessToken,
        };
      }
      return options;
    };
  } else {
    console.warn("VHS plugin is not available in this version of Video.js.");
  }

  React.useEffect(() => {

    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
      const videoElement = videoRef.current;

      if (!videoElement) return;
      if (props?.liveData?.channel_id) {
        if (props?.liveData?.ssai_enabled) {
          ssaiAdParam(props?.liveData, appInfo).then((response) => {
            createSSAI(props?.liveData.ssai_link, videoElement, response, false)

          })
        } else {
          const player = playerRef.current = videojs(videoElement, { ...options, autoplay: !kids }, () => {
            onReady && onReady(player);
          });
          try {
            if (!is_live) {
              createRestartButton && createRestartButton(player);
            }
          } catch (e) {
            console.warn('Restart button init failed', e);
          }
        }
      } else {
        const player = playerRef.current = videojs(videoElement, { ...options, autoplay: !kids }, () => {
          onReady && onReady(player);
        });
        try {
          if (!is_live) {
            createRestartButton && createRestartButton(player);
          }
        } catch (e) {
          console.warn('Restart button init failed', e);
        }
      }


      // You could update an existing player in the `else` block here
      // on prop change, for example:
    } else {
      //   const player = playerRef.current;

      //   player.autoplay(options.autoplay);
      //   player.src(options.sources);
    }
  }, [options, videoRef]);

  function createRestartButton(player) {
    if (!player) return;

    try {
      try {
        if (!videojs.getComponent('RestartButton')) {
          const Button = videojs.getComponent('Button');

          const RestartButton = videojs.extend(Button, {
            constructor: function(player, options) {
              Button.apply(this, arguments);
              this.controlText('Start Over');
            },
            handleClick: function() {
              const p = this.player();
              try {
                p.currentTime(0);
                p.play();
                try {
                  this.el() && this.el().blur && this.el().blur();
                } catch (err) {
                }
              } catch (err) {
                console.warn('Restart button action error', err);
              }
            }
          });

          videojs.registerComponent('RestartButton', RestartButton);
        }
      } catch (err) {
      }

      const controlBar = player.getChild('controlBar');
      if (controlBar && !controlBar.getChild('RestartButton')) {
        let insertIndex;
        const fs = controlBar.getChild('fullscreenToggle') || controlBar.getChild('FullscreenToggle') || controlBar.getChild('fullScreenToggle');
        if (fs) {
          const children = controlBar.children ? controlBar.children() : [];
          insertIndex = children.indexOf(fs);
          if (insertIndex < 0) insertIndex = undefined;
        }

        controlBar.addChild('RestartButton', {}, insertIndex);
        const btn = controlBar.getChild('RestartButton');
        if (btn && btn.el()) {
          btn.el().classList.add('vjs-restart-button', 'vjs-control');
          btn.el().setAttribute('aria-label', 'Start Over');
          try {
            btn.el().innerHTML = `\n              <svg class="vjs-restart-svg" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n                <path d="M12 5V1L8 5l4 4V6c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z" />\n              </svg>\n              <span class="vjs-control-text">Start Over</span>\n            `;
          } catch (e) {
          }
        }
      }

      const disableRestart = () => {
        const btn = player.getChild('controlBar')?.getChild('RestartButton');
        if (btn && btn.disable) btn.disable();
      };
      const enableRestart = () => {
        const btn = player.getChild('controlBar')?.getChild('RestartButton');
        if (btn && btn.enable) btn.enable();
      };

      player.on && player.on('adstart', disableRestart);
      player.on && player.on('adend', enableRestart);
      player.on && player.on('ads-ad-started', disableRestart);
      player.on && player.on('ads-ad-ended', enableRestart);
      player.on && player.on('ima3-started', disableRestart);
      player.on && player.on('ima3-complete', enableRestart);

    } catch (e) {
      console.warn('createRestartButton error', e);
    }
  }

  useEffect(() => {
    let clear = true
    if (props?.liveData) {
      createSSAI("", "", "", clear)

    }
    return () => {
      createSSAI("", "", "", clear)
    }
  }, [props?.liveData])

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const player = playerRef.current;

    console.log('typeof player.ima', props);

    try {
      if (props?.adUrl) {
        var imaOptions = {
          adTagUrl: props?.adUrl
        };

        try {
          player.ima(imaOptions)
        } catch (error) {
          console.log('ima error', error);

        }

        player.on('error', () => {
          const error = player.error(); // Get the error details
          if (error) {
            console.log("Video.js Error: ", error);

            // Example: Logging specific error codes
            console.log(`Error Code: ${error.code} - ${error.message || "No message provided"}`);

            if (error.code === 4) {
              console.log("MEDIA_ERR_SRC_NOT_SUPPORTED: The video source is unsupported.");
            }
          }
        });

        // Pause the video when ad starts
        player.on('ads-ad-started', () => {
          const videoElement = videoRef.current;
          // console.log('ads-ad-started', videoElement);

          try {
            // console.log('Before pause:', player.paused());  // Log current state
            document.getElementById('vjs_video_player_html5_api').pause()
            // console.log('After pause:', player.paused());  // Log state after pause
          } catch (error) {
            console.log('error', error);

          }




          // videoElement.pause();
        });

        player.on('play', () => {
          const posterImage = player.el().querySelector('.vjs-poster');
          if (posterImage && isRadioLive) {
            // posterImage.style.display = 'block'; // Keep the poster visible
          }
        });

        // Resume the video when ad ends
        player.on('ads-ad-ended', () => {
          // console.log('ads-ad-ended');

          player.play();
        });

        player.on('ima3-started', () => {
          // console.log('ima3 Ad started');
          player.pause(); // Pause video when ad starts
        });

        player.on('ima3-complete', () => {
          // console.log('ima3 Ad completed');
          player.play(); // Resume video when ad ends
        });

      }
    } catch (error) {
      console.log('ima error', error);

    }

    return () => {
      if (player) {
        player.dispose();
        playerRef.current = null;

      }
    };


  }, [videoRef]);

  useEffect(() => {
    setControlColor(projectInfo?.projectConfig?.config?.BUTTON_COLOR || '#fff');
  }, [projectInfo]);

  function createSSAI(url, videoElem, adsParams, clearFlag) {


    let eachSecondInterval;
    let refreshInterval;
    if (clearFlag === false) {

      sessionCreation(url);

      var arr = url.split("/");
      var result = arr[0] + "//" + arr[2]
      var domainOfUrl = result;



      var previousTime = 0;
      var beaconTime = [];
      var trackingUrl = domainOfUrl;
      var beaconData = []
      var whereYouAt = 0;
      eachSecondInterval = setInterval(eachSecond, 1000);




      function isInArray(value, array) {
        return array.indexOf(value);
      }


      function eachSecond() {


        whereYouAt = whereYouAt + 1;
        whereYouAt = Math.round(whereYouAt)



        if (whereYouAt != previousTime) {
          previousTime = whereYouAt;

          if (beaconTime.length > 0) {

            if (isInArray(whereYouAt, beaconTime) > -1) {

              var temp = beaconData[isInArray(whereYouAt, beaconTime)].beaconUrls;
              for (var i = 0; i < temp.length; i++) {

                callAdTrackingUrl(temp[i])
              }



            }



          }

        }
      }


      function callAPI(url) {

        var request = new XMLHttpRequest();
        request.onreadystatechange = function () {
          if (request.readyState == 4 && request.status == 200) {


            var trackingData = JSON.parse(request.responseText);

            var avails = trackingData.avails;



            for (let k = 0; k < avails.length; k++) {


              var avail = avails[k];

              var ads = avail.ads;


              for (let j = 0; j < ads.length; j++) {

                var trackingEvents = ads[j].trackingEvents;

                for (k = 0; k < trackingEvents.length; k++) {

                  var trackingEvent = trackingEvents[k]



                  if (trackingEvent && trackingEvent.eventType) {
                    var eventType = trackingEvent.eventType;
                    if (eventType == "start" || eventType == "firstQuartile" || eventType == "firstQuartile" || eventType == "midpoint" || eventType == "impression") {
                      beaconTime.push(Math.round(trackingEvent.startTimeInSeconds))
                      beaconData.push(trackingEvent)


                    }
                  }

                }



              }




            }


          } else if (request.status == 502) {

            beaconTime = [];

          }

        }
        request.open("GET", url);
        request.send(null);
      }

      function sessionCreation(theUrl) {

        var data = JSON.stringify(adsParams);

        var xhr = new XMLHttpRequest();


        xhr.addEventListener("readystatechange", function () {
          if (this.readyState === 4) {
            var jsonResult = JSON.parse(this.responseText)


            // const player = videojs(videoElem);

            const player = playerRef.current = videojs(videoElem, options, () => {
              onReady && onReady(player);
            });
            try {
              if (!is_live) {
                createRestartButton && createRestartButton(player);
              }
            } catch (e) {
              console.warn('Restart button init failed (SSAI)', e);
            }

            if (jsonResult) {
              player.src({
                src: domainOfUrl + jsonResult.manifestUrl,
                type: 'application/x-mpegURL',
              });
              trackingUrl = trackingUrl + jsonResult.trackingUrl;
              refreshInterval = setInterval(refresh, 10000);
            }




          }
        });

        xhr.open("POST", theUrl);
        xhr.setRequestHeader("content-type", "application/json");


        xhr.send(data);


      }

      function refresh() {
        callAPI(trackingUrl);
      }



      function callAdTrackingUrl(theUrl) {


        var i = document.createElement("img");
        i.src = theUrl;



      }
    } else if (clearFlag === true) {
      clearTimeout(eachSecondInterval)
      clearTimeout(refreshInterval)
    }




  }
  return (
    <div data-vjs-player style={{position: 'relative'}}>
      <style>{`
        .video-js .vjs-poster {
          background-size: contain !important;
          background-position: center center !important;
          background-repeat: no-repeat !important;
        }
        .video-js .vjs-poster img,
        .video-js video {
          object-fit: contain !important;
          object-position: center !important;
        }
        ::cue,
        video::cue {
          font-size: 15px !important;
          line-height: 1.3 !important;
        }
        .video-js .vjs-text-track-display {
          font-size: 15px !important;
        }
        .video-js .vjs-text-track-cue,
        .vjs-text-track-cue {
          font-size: 15px !important;
          line-height: 1.3 !important;
        }
        .video-js .vjs-text-track-cue > div,
        .vjs-text-track-cue > div {
          font-size: 15px !important;
          line-height: 1.3 !important;
          padding: 2px 6px !important;
        }
        @media (max-width: 768px) {
          ::cue,
          video::cue,
          .video-js .vjs-text-track-display,
          .video-js .vjs-text-track-cue,
          .video-js .vjs-text-track-cue > div {
            font-size: 13px !important;
          }
        }
        .video-js .vjs-menu-button-popup .vjs-menu {
          bottom: 100% !important;
          margin-bottom: 0 !important;
          padding-bottom: 10px !important;
        }
        .video-js .vjs-menu-button-popup .vjs-menu:before {
          content: '' !important;
          position: absolute !important;
          left: -20px !important;
          right: -20px !important;
          bottom: -20px !important;
          height: 30px !important;
          background: transparent !important;
          z-index: 1 !important;
        }
        .video-js .vjs-menu-button-popup:hover .vjs-menu,
        .video-js .vjs-menu-button-popup.vjs-hover .vjs-menu,
        .video-js .vjs-menu-button-popup .vjs-menu:hover {
          display: block !important;
          opacity: 1 !important;
          visibility: visible !important;
        }
        .video-js .vjs-menu-button-popup .vjs-menu .vjs-menu-content {
          background-color: rgba(0, 0, 0, 0.9) !important;
          border-radius: 6px !important;
          padding: 6px 0 !important;
          bottom: 0 !important;
        }
        .video-js .vjs-menu-button-popup .vjs-menu .vjs-menu-item {
          padding: 8px 16px !important;
          font-size: 14px !important;
          text-transform: capitalize !important;
          cursor: pointer !important;
        }
        .video-js .vjs-menu-button-popup .vjs-menu .vjs-menu-item:hover,
        .video-js .vjs-menu-button-popup .vjs-menu .vjs-menu-item.vjs-selected {
          background-color: rgba(255, 255, 255, 0.2) !important;
          color: #ffffff !important;
        }
        .video-js .vjs-play-progress {
          background-color: ${controlColor};
        }
        .videojs-watermark {
          position: absolute;
          top: 12px;
          right: 12px;
          z-index: 1000;
          pointer-events: none;
          max-width: 120px;
          max-height: 60px;
        }
       
        .video-js.vjs-fullscreen ~ .videojs-watermark,
        .vjs-fullscreen .videojs-watermark {
          position: fixed !important;
          top: 20px !important;
          right: 20px !important;
        }
        }
        .vjs-control:hover {
          color: ${controlColor}; 
        }
        .vjs-volume-level {
          background-color: ${controlColor} !important;
        }
        .vjs-control:hover > .vjs-icon-placeholder,
        .vjs-control:hover > .vjs-icon-play,
        .vjs-control:hover > .vjs-icon-pause,
        .vjs-control:hover > .vjs-icon-volume-high,
        .vjs-control:hover > .vjs-icon-captions,
        .vjs-control:hover > .vjs-icon-fullscreen-enter,
        .vjs-control:hover > .vjs-icon-fullscreen-exit {
          background: ${controlColor}; 
          color: ${controlColor}; 
        }
        .vjs-restart-button {
          color: rgba(255,255,255,0.85);
          padding: 0 8px;
          font-size: 13px;
          display: inline-flex;
          align-items: center;
        }
        .vjs-restart-button .vjs-restart-svg {
          width: 18px;
          height: 18px;
          fill: rgba(255,255,255,0.85);
          vertical-align: middle;
        }
        .vjs-restart-button:hover,
        .vjs-restart-button:focus {
          color: ${controlColor};
        }
        .vjs-restart-button:hover .vjs-restart-svg,
        .vjs-restart-button:focus .vjs-restart-svg {
          fill: ${controlColor};
        }
        .vjs-restart-button .vjs-control-text {
          position: absolute;
          left: -9999px;
          width: 1px;
          height: 1px;
          overflow: hidden;
        }
      `}</style>
   
      {props?.watermark && (
        <img
          src={props?.watermark}
          alt="Watermark"
          className="videojs-watermark"
          aria-hidden="true"
        />
      )}
      <video ref={videoRef} id='vjs_video_player' className='video-js vjs-big-play-centered' poster={poster} muted={options?.muted} playsInline>
        {
          props?.closedCaptions?.map((item, index) => (
            <track key={index} kind='captions' src={item?.closed_caption_url} srclang={item?.short_code} label={item?.language_name} default={projectInfo?.projectConfig?.config?.DEFAULT_CAPTIONS_ON == "true" ? true : false} />
          ))
        }
        {
          props?.subtitles?.map((item, index) => (
            <track key={index} kind='captions' src={item?.subtitle_url} srclang={item?.short_code} label={item?.language_name} default={projectInfo?.projectConfig?.config?.DEFAULT_CAPTIONS_ON == "true" ? true : false} />
          ))
        }
      </video>
    </div>
  );
}

export default VideoJS;
